import { useConfig } from "@/hooks/use-config";

export function Footer() {
  const { data: config } = useConfig();

  const text = config
    ? `${config.environment} | Built with Nymbl LLC for Urban Solutions Group. Version ${config.version.major}.${config.version.minor}.${config.version.commit}`
    : null;

  return (
    <footer className="app-footer">
      {text ?? <span className="app-footer__skeleton" aria-hidden="true" />}
    </footer>
  );
}
